import statistical from './statistical'
import statistic from './statistic'
import dictionary from './dictionary'
import driverSettlement from './driver-settlement'
import undefinedTariff from './undefined-tariff'

export default {
  name: 'reports',
  path: 'reports',
  meta: {
    label: 'reports',
    auth: 'report'
  },
  component: {
    name: 'Report',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    statistical,
    statistic,
    dictionary,
    driverSettlement,
    undefinedTariff
  ]
}
